<div class="transport-options-structure-editor">

  <div class="editor-layout">

    <div class="options-structure">
      <div class="options-structure-layout">

        <app-drop-zone orientation="vertical" (drop)="onDropToColumnDropzone($event, null)"
        (dragover)="onDragOverColumnDropzone($event)"></app-drop-zone>

        @for (col of columns; track col) {
          <div class="column">
            <div class="column-reorder-handle" draggable="true" (dragstart)="onDragColumnStart($event, col)"
              (dragend)="onDragColumnEnd($event)">
              <div aria-hidden="false">
                <sc-flex>
                  <sc-icon iconClass="fa-caret-left"></sc-icon>
                  <sc-icon iconClass="fa-grip-lines-vertical"></sc-icon>
                  <sc-icon iconClass="fa-caret-right"></sc-icon>
                </sc-flex>
              </div>
            </div>
            <app-drop-zone (dragover)="onDragOverColumnRowDropzone($event)"
              (drop)="onDropOptionToFirstRowOfColum($event, col)">
            </app-drop-zone>
            @for (option of col.options; track option) {
              @if (!option.deleted) {
                <div class="parent-option">
                  <div class="parent-option-layout">
                    <div class="reorder-handle" draggable="true" (dragstart)="onDragOptionStart($event, option)"
                      (dragend)="onDragOptionEnd($event)">
                      <div class="reorder-handle-layout" aria-hidden="false">
                        <sc-icon iconClass="fa-bars"></sc-icon>
                      </div>
                    </div>
                    <div class="parent-option-content">
                      <div class="parent-option-title-bar">
                        <div class="title">
                          {{'' | translateDictionaryEntry: [option.name,
                          translationService.language]}}
                        </div>
                        <sc-content-spacer grow></sc-content-spacer>
                        <div class="button-label" (click)="editTransportOption(option)">
                          <sc-icon iconClass="fa-edit"></sc-icon>
                        </div>
                        <sc-content-spacer></sc-content-spacer>
                        <div class="button-label" (click)="deleteTransportOption(option)">
                          <sc-icon iconClass="fa-trash"></sc-icon>
                        </div>
                      </div>
                      <div class="child-options">
                        <div class="child-options-layout">
                          <app-drop-zone (dragover)="onDragOverChildRowDropzone($event)"
                            (drop)="onDropOptionAsFirstChild($event, option)">
                          </app-drop-zone>
                          @for (childOption of option.children; track childOption) {
                            @if (!childOption.deleted) {
                              <div class="child-option">
                                <div class="child-option-reorder-handle" draggable="true"
                                  (dragstart)="onDragOptionStart($event, childOption)" (dragend)="onDragOptionEnd($event)">
                                  <div aria-hidden="false">
                                    <sc-icon iconClass="fa-bars"></sc-icon>
                                  </div>
                                </div>
                                <div class="content">
                                  <div class="child-option-title-bar">
                                    <div class="title">
                                      {{'' | translateDictionaryEntry: [childOption.name,
                                      translationService.language]}}
                                    </div>
                                    <sc-content-spacer grow></sc-content-spacer>
                                    <div class="button-label" (click)="editTransportOption(childOption)">
                                      <sc-icon iconClass="fa-edit"></sc-icon>
                                    </div>
                                    <sc-content-spacer></sc-content-spacer>
                                    <div class="button-label" (click)="deleteTransportOption(childOption)">
                                      <sc-icon iconClass="fa-trash"></sc-icon>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (!childOption.deleted) {
                              <app-drop-zone (dragover)="onDragOverChildRowDropzone($event)"
                                (drop)="onDropOptionAfterChild($event, option, childOption)">
                              </app-drop-zone>
                            }
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (!option.deleted) {
                <app-drop-zone (dragover)="onDragOverColumnRowDropzone($event)"
                  (drop)="onDropOptionToRowOfColumn($event, col, option.rowIndex)">
                </app-drop-zone>
              }
            }
          </div>
          <app-drop-zone orientation="vertical" (drop)="onDropToColumnDropzone($event, col)"
          (dragover)="onDragOverColumnDropzone($event)"></app-drop-zone>
        }

      </div>
    </div>

  </div>

</div>
